import { api } from './api';

export interface ConteoFisico {
  id: number;
  tenantId: number;
  sucursalId: number;
  usuarioId?: number;
  estado: 'pendiente' | 'en_proceso' | 'finalizado' | 'cancelado';
  fechaInicio?: string;
  fechaFin?: string;
  notas?: string;
  createdAt?: string;
  updatedAt?: string;
  sucursal?: { id: number; name: string };
  usuario?: { id: number; name: string; email: string };
  detalles?: ConteoFisicoDetalle[];
}

export interface ConteoFisicoDetalle {
  id: number;
  conteoFisicoId: number;
  productoId: number;
  varianteId?: number;
  cantidadSistema: number;
  cantidadContada: number;
  diferencia: number;
  costoUnitario: number;
  notas?: string;
  producto?: { id: number; name: string; sku?: string };
  variante?: { id: number; name: string; sku?: string };
}

export interface ConteoFisicoCreate {
  sucursalId: number;
  notas?: string;
}

export interface ConteoFisicoDetalleCreate {
  productoId: number;
  varianteId?: number;
  cantidadContada: number;
  notas?: string;
}

export interface FinalizarConteoRequest {
  aplicarAjustes?: boolean;
}

export const conteoFisicoService = {
  getAll: async (sucursalId?: number, estado?: string): Promise<{ data: { conteos: ConteoFisico[] } }> => {
    const params = new URLSearchParams();
    if (sucursalId) params.append('sucursalId', sucursalId.toString());
    if (estado) params.append('estado', estado);
    const query = params.toString();
    const response = await api.get<{ data: { conteos: ConteoFisico[] } }>(`/conteos-fisicos${query ? `?${query}` : ''}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { conteo: ConteoFisico } }> => {
    const response = await api.get<{ data: { conteo: ConteoFisico } }>(`/conteos-fisicos/${id}`);
    return response.data;
  },

  create: async (data: ConteoFisicoCreate): Promise<{ data: { conteo: ConteoFisico } }> => {
    const response = await api.post<{ data: { conteo: ConteoFisico } }>('/conteos-fisicos', data);
    return response.data;
  },

  iniciar: async (id: number): Promise<{ data: { conteo: ConteoFisico } }> => {
    const response = await api.post<{ data: { conteo: ConteoFisico } }>(`/conteos-fisicos/${id}/iniciar`);
    return response.data;
  },

  agregarDetalle: async (id: number, data: ConteoFisicoDetalleCreate): Promise<{ data: { detalle: ConteoFisicoDetalle } }> => {
    const response = await api.post<{ data: { detalle: ConteoFisicoDetalle } }>(`/conteos-fisicos/${id}/detalles`, data);
    return response.data;
  },

  finalizar: async (id: number, aplicarAjustes = false): Promise<{ data: { conteo: ConteoFisico } }> => {
    const response = await api.post<{ data: { conteo: ConteoFisico } }>(`/conteos-fisicos/${id}/finalizar`, {
      aplicarAjustes
    });
    return response.data;
  },

  cancelar: async (id: number): Promise<{ data: { conteo: ConteoFisico } }> => {
    const response = await api.post<{ data: { conteo: ConteoFisico } }>(`/conteos-fisicos/${id}/cancelar`);
    return response.data;
  },

  eliminarDetalle: async (id: number, detalleId: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/conteos-fisicos/${id}/detalles/${detalleId}`);
    return response.data;
  }
};

